import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, LoadScript, Polygon } from "@react-google-maps/api";
import { googleMapsApiKey } from "../../Urls/Services/Api_urls";

const MapRender2 = (props) => {
  const path = props.data;

  const [center, setCenter] = useState({
    lat: 3.3750139010000453,
    lng: -76.564036637999948,
  });
  
  const polygonRefs = useRef([]);

  useEffect(() => {
    if (props.data.length > 0) {
      const newCenter = {
        lat: props.data[0].lat,
        lng: props.data[0].lng,
      };
      setCenter(newCenter);
    }
   
  
    console.log(newPaths);
  }, [props.data]);

  const newPaths = path.map((e) => ({
    lat: e.lat,
    lng: e.lng,
  }));

  const handleEdit = (index, polygon) => {
    

    const newPolygons = [...props.data];
    newPolygons[index] = newPaths;
    props.onPolygonEdit(newPolygons); // Notificar al componente padre
  };

  

  return (
    <LoadScript googleMapsApiKey={googleMapsApiKey}>
      <GoogleMap
        mapContainerStyle={{ width: props.width, height: props.height }}
        zoom={props.zoom}
        center={center}
      >
       
          
          <Polygon

         
        
            paths={newPaths} // paths es un array de coordenadas [{lat, lng}, {lat, lng}, ...]
            options={{
              fillColor: "#771EEB",
              fillOpacity: 0.5,
              strokeColor: "#771EEB",
              strokeOpacity: 0.8,
              strokeWeight: 2,
            }}
           
          />
     
      </GoogleMap>
    </LoadScript>
  );
};

export default MapRender2;